<script setup>
import { router, Link } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import DeleteUserForm from '@/Pages/Profile/Partials/DeleteUserForm.vue';
import JetSectionBorder from '@/Jetstream/SectionBorder.vue';
import LogoutOtherBrowserSessionsForm from '@/Pages/Profile/Partials/LogoutOtherBrowserSessionsForm.vue';
import TwoFactorAuthenticationForm from '@/Pages/Profile/Partials/TwoFactorAuthenticationForm.vue';
import UpdatePasswordForm from '@/Pages/Profile/Partials/UpdatePasswordForm.vue';
import UpdateProfileInformationForm from '@/Pages/Profile/Partials/UpdateProfileInformationForm.vue';
import DashboardSidebar from '@/Jetstream/DashboardSidebar.vue';

const props = defineProps({
    confirmsTwoFactorAuthentication: Boolean,
    sessions: Array,
    teamAdminUsers: Array,
    teamMemberUsers: Array,
    isOtherAdmins: Boolean,
    isMembers: Boolean,
    otherTeamMembers: Boolean,
    programme: Object,
    organisation: Object,
    languages: Array
});

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";

</script>



<template>
    <AppLayout title="Profile">

       <div class="container mx-auto flex flex-col lg:flex-row justify-between w-full">

            <div id="sos-programme-dashboard-sidebar" class="order-2 lg:order-1 w-full lg:w-1/4 xl:w-1/5 min-h-screen p-10">
                <DashboardSidebar :programme="programme" :organisation="organisation" />
            </div>

            <div class="order-1 lg:order-2 w-full lg:w-3/4 xl:w-4/5 sos-programme-dashboard-content">
                <div class="overflow-hidden">
                    <h1 class="dashboard-title pt-5 pl-10">
                        {{ $t('user.title') }}
                    </h1>
                    <div class="p-10 pt-5 lg:pr-0">
                        <div v-if="$page.props.jetstream.canUpdateProfileInformation">
                            <UpdateProfileInformationForm :user="$page.props.auth.user" :programme="programme" :organisation="organisation" :languages="props.languages" />

                            <JetSectionBorder />
                        </div>

                        <div>

                            <div class="md:grid md:grid-cols-3 md:gap-6">


                                <div class="md:col-span-1 flex justify-between">
                                    <div class="px-4 sm:px-0">
                                        <h3 class="text-lg font-medium text-gray-900">
                                            {{ $t('user.information.title') }}
                                        </h3>

                                        <p class="mt-1 text-sm text-gray-600">
                                            {{ $t('user.information.description') }}
                                        </p>
                                    </div>

                                </div>


                                <div class="mt-5 md:mt-0 md:col-span-2">

                                    <Link :href="route(urlNamePrefix+'custom-questions.view')" class="inline-flex items-center px-4 py-2 bg-gray-500 border border-transparent rounded-md font-semibold text-xs text-white tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25 transition normal-case">
                                        {{ $t('user.information.edit') }}
                                    </Link>

                                </div>


                            </div>
                        </div>
                        <JetSectionBorder />

                        <div v-if="$page.props.jetstream.canUpdatePassword">
                            <UpdatePasswordForm class="mt-10 sm:mt-0" />

                            <JetSectionBorder />
                        </div>

                        <div v-if="$page.props.jetstream.canManageTwoFactorAuthentication">
                            <TwoFactorAuthenticationForm
                                :requires-confirmation="confirmsTwoFactorAuthentication"
                                :programme="programme"
                                :organisation="organisation"
                                class="mt-10 sm:mt-0"
                            />

                            <JetSectionBorder />
                        </div>

                        <LogoutOtherBrowserSessionsForm :sessions="sessions" class="mt-10 sm:mt-0" />


                        <template v-if="$page.props.jetstream.hasAccountDeletionFeatures">
                            <JetSectionBorder />

                            <DeleteUserForm :teamAdminUsers="teamAdminUsers" :teamMemberUsers="teamMemberUsers" :isOtherAdmins="isOtherAdmins" :otherTeamMembers="otherTeamMembers" :isMembers="isMembers" class="mt-10 sm:mt-0" />
                        </template>

                    </div>
                </div>
            </div>
        </div>

    </AppLayout>
</template>
